import '.fs{box-sizing:border-box;}.ssr-plugin'
import '.ft{border:1px solid var(--gray-200);}.ssr-plugin'
import '.cc{border-radius:1rem;}.ssr-plugin'
import '.fu{padding:1.25rem 1.25rem;}.ssr-plugin'
import '.fv{width:4rem;}.ssr-plugin'
import '.bu{height:4rem;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.fw{gap:2.5rem;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.a0{gap:1rem;}.ssr-plugin'
import '.l{display:grid;}.ssr-plugin'
import '.ay{min-width:0px;}.ssr-plugin'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled, type Style } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export type CardsSectionItem = {
  title: string
  description: string
  imageSrc?: string
  faIcon?: IconDefinition
}

export type CardsSectionProps = {
  isMobile: boolean
  title: string
  intro: string
  items: ReadonlyArray<CardsSectionItem>
  style?: Style
}

const PainPointCard = ({ item }: { item: CardsSectionItem }) => {
  return (
    <div className="fs ft cc fu"
    >
      <Row gap="2rem">
        {item.imageSrc ? (
          <div className="fv bu bn c h d"
          >
            <Image src={item.imageSrc} alt={item.title} />
          </div>
        ) : item.faIcon ? (
          <div className="fv bu bn c h d"
          >
            <FontAwesomeIcon
              icon={item.faIcon}
              style={{
                color: 'var(--palette-blue-800)',
                width: '2.25rem',
                height: '2.25rem',
              }}
            />
          </div>
        ) : null}
        <Column gap="1rem">
          <Title.H4 style={{ marginBottom: 0 }}>{item.title}</Title.H4>
          <Text.Medium
            color="var(--palette-blue-600)"
            style={{ marginBottom: 0 }}
          >
            {item.description}
          </Text.Medium>
        </Column>
      </Row>
    </div>
  )
}

const CardsSection = ({ isMobile, title, intro, items }: CardsSectionProps) => {
  return (
    <div className="c g a6 fw u"
    >
      <div className="c g a0"
        style={{
          maxWidth: isMobile ? '100%' : '33rem',
        }}
      >
        <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
        <Text.Medium
          color="var(--palette-blue-600)"
          style={{ marginBottom: 0, maxWidth: '100%' }}
        >
          {intro}
        </Text.Medium>
      </div>
      <div className="l a0 u ay"
        style={{
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',}}
      >
        {items.map((item) => (
          <PainPointCard key={item.title} item={item} />
        ))}
      </div>
    </div>
  )
}

export default CardsSection
